import React, { useContext }  from 'react';
import styled from 'styled-components'
import ProfilePicture from './components/profile-picture'
import ProfileInfo from './components/profile-info'
import ChangePassword from './components/change-password';
import StripeInfo from './components/stripe-info'
import MissedTracking from './components/missed-tracking'
import SetMessaging from './components/messaging'
import SetMealPlanner from './components/meal-planner'
import CancelAccount from './components/cancel-account'
import { AuthContext } from '../../../../auth-context'

const Page = styled.div`
`;

const Content = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  padding: 32px 16px;

  @media(max-width: 900px) {
    padding: 16px 8px;
  }
`;

const MarginSpacer = styled.div`
  height: 32px;
`

const Profile = () => {
  const { user } = useContext(AuthContext);

  return (
    <Page>
      <Content>
        <ProfilePicture />
        <MarginSpacer />
        <ProfileInfo />
        <MarginSpacer />
        <ChangePassword />
        <MarginSpacer />
        <MissedTracking />
        {user.role_id === 1 && 
          <>
            <MarginSpacer />
            <SetMessaging />
            <MarginSpacer />
            <SetMealPlanner />
            <MarginSpacer />
            {user.branch === 0 &&
              <>
                <StripeInfo />
                <MarginSpacer />
              </>
            }
            <CancelAccount />
          </>
        }
      </Content>
    </Page>
  )
}

export default Profile